module.exports = __webpack_public_path__ + "img/bp2-4-comp.glb";